__turbopack_context__.v({
  "body": "YpWWPW_body",
  "clearAllBtn": "YpWWPW_clearAllBtn",
  "footer": "YpWWPW_footer",
  "header": "YpWWPW_header",
  "headerTitle": "YpWWPW_headerTitle",
  "root": "YpWWPW_root",
});
